import { render, staticRenderFns } from "./AlarmStatistics.vue?vue&type=template&id=7042ec56&scoped=true"
import script from "./AlarmStatistics.vue?vue&type=script&lang=js"
export * from "./AlarmStatistics.vue?vue&type=script&lang=js"
import style0 from "./AlarmStatistics.vue?vue&type=style&index=0&id=7042ec56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042ec56",
  null
  
)

export default component.exports